import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'hrm-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, OnDestroy {
  @ViewChild(MatSidenav)
  sidenav!: MatSidenav;

  showNavBar = false;
  hideHeader: boolean;
  showMobilePanel: boolean = false;
  showMobile: boolean;

  collapseMobile: boolean = false;
  showExternalHeader: boolean = false;

  expandMobile: boolean;
  expandNoMobile: boolean;
  private readonly ngUnsubscribe = new Subject<void>();
  constructor(
    private observer: BreakpointObserver,
  ) { }

  ngOnInit(): void {
    this.showExternalHeader = false;
  }

  ngAfterViewInit() {
    this.observer
      .observe(['(max-width: 800px)'])
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
        if (res.matches) {
          this.showNavBar = false;
        } else {
          this.showNavBar = true;
        }
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
